import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  async function submit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success("Password updated. Please sign in.");
      nav("/doctor/login");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen bg-slate-50 grid place-items-center p-4">
      <div className="w-full max-w-md bg-white rounded-3xl shadow-xl p-8">
        <h1 className="text-xl font-display font-bold text-slate-900">Set a new password</h1>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <input type="password" required minLength={6} placeholder="New password (min 6 chars)" value={pw} onChange={(e) => setPw(e.target.value)} className="w-full px-4 py-3 border border-slate-300 rounded-xl" data-testid="reset-password-input" />
          <button disabled={loading || !token} className="w-full bg-emerald-700 hover:bg-emerald-800 text-white rounded-xl py-3 font-semibold disabled:opacity-50" data-testid="reset-submit-btn">
            {loading ? "Updating..." : "Update password"}
          </button>
        </form>
        <Link to="/doctor/login" className="block mt-5 text-center text-sm text-slate-600 hover:text-slate-900">← Back to sign in</Link>
      </div>
    </div>
  );
}
